export default __webpack_public_path__ + "static/035-9622453328f541aef0c180397a0292ce.png";